/**
 * PinToggle — pin a catalogue entry to the top (brief-26).
 *
 * VISIBLE AT REST. The pin used to appear only on card hover/focus, following
 * the same two-stage rule as the action row. The 2026-08-02 CTA-at-rest ruling
 * reversed that for `.dp-card__cta`, and
 * decision-2026-08-02-tile-is-a-pointer-manage-is-the-workbench forces the same
 * reversal here: the collapsed tile carries exactly TWO affordances, Manage and
 * Pin, and a two-affordance card cannot hide one of the two. Hover-to-reveal was
 * survivable when the pin sat fourth in a row of visible buttons; as half the
 * card's entire action surface it is not.
 *
 * A PINNED entry was always visible at rest and still is — it is explaining why
 * that entry is at the top of the list.
 */

import { t } from '../i18n';

interface PinToggleProps {
  pinned: boolean;
  title: string;
  onToggle: () => void;
}

export default function PinToggle({ pinned, title, onToggle }: PinToggleProps) {
  const label = (pinned ? t('tile.pin.unpin') : t('tile.pin.pin')).replace('{{service}}', title);

  return (
    <button
      type="button"
      className={`dp-pin${pinned ? ' dp-pin--on' : ''}`}
      aria-pressed={pinned}
      aria-label={label}
      title={label}
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
    >
      <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
        <path
          d="M6 1.5h4a.5.5 0 0 1 .35.85L9.5 3.2v3.3l2.2 1.9a.8.8 0 0 1 .3.6v.5a.5.5 0 0 1-.5.5H8.6v4.2a.6.6 0 0 1-1.2 0V10H4.5a.5.5 0 0 1-.5-.5V9a.8.8 0 0 1 .3-.6l2.2-1.9V3.2l-.85-.85A.5.5 0 0 1 6 1.5Z"
          fill={pinned ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
